import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
export function setupScrollTopToBottom() {
    new Splide('.splide', {
        type: 'loop',
        autoplay: true,
        direction: 'ttb',
        gap: '2px',
        height: '492px',
        // height   : '202px',
        width: '100%',
        padding: '70px',
        arrows: false,
        pagination: false,
        wheel: true,
        releaseWheel: true,
        waitForTransition: true,
    }).mount();
}
